import React, { useEffect, useRef, useState } from "react";
import Footer from "../components/footer";
import NavBar from "../components/navbar";
import { PayPalButtons, PayPalScriptProvider } from "@paypal/react-paypal-js";
import PocketBase from "pocketbase";

const initialOptions = {
  "client-id":
    "AcF6WJ9hDUtDBtTnnjwwlP5iyNCRNFO-aZj-4mC9th1QrZbcxhgBPkZJ1zXSMDHB_Kp3Ty2zxXjQWRsS",
  currency: "USD",
  intent: "capture",
};
const pb = new PocketBase("https://friendsofstandrewsstatepark.org");

export default function Join() {
  let orderIDLoc;
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [success, setSuccess] = useState(false);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [ErrorMessage, setErrorMessage] = useState("");
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [orderID, setOrderID] = useState(false);
  useEffect(() => {
    if (success) alert("Payment successful!!");
    if (ErrorMessage) alert(ErrorMessage);
  }, [success, ErrorMessage]);

  const createOrder = (data, actions) =>
    actions.order
      .create({
        purchase_units: [
          {
            description: "Friends of St. Andrew's State Park Membership",
            amount: {
              currency_code: "USD",
              value: membershipLevel.current.value,
            },
          },
        ],
      })
      .then((orderID) => {
        orderIDLoc = orderID;
        setOrderID(orderID);
        return orderID;
      });

  const onApprove = (data, actions) =>
    actions.order.capture().then(function (details) {
      const { payer } = details;
      const record = async () =>
        await pb.collection("members").create({
          paypal_order_id: orderIDLoc,
          first_name: payer.name.given_name,
          last_name: payer.name.surname,
          email: payer.email_address,
          payer_id: payer.payer_id,
          payment_amount: membershipLevel.current.value,
        });
      record().then(() => setSuccess(true));
    });

  const onError = () => setErrorMessage("An Error occured with your payment ");

  let membershipLevel = useRef();

  return (
    <div className="content d-flex flex-column justify-content-between fsa-body-bg">
      <NavBar />
      <div className="d-flex flex-column align-items-center px-3 pt-4 pb-5">
        <h1 className="fsa-section-title">Join Friends</h1>

        <div className="card mb-4" style={{ maxWidth: 520, width: "100%" }}>
          <div className="card-header fsa-card-header">
            <h5
              className="mb-0"
              style={{ color: "white", fontFamily: "inherit" }}
            >
              Select Membership Level
            </h5>
          </div>
          <div className="card-body">
            <select
              id="membershipSelection"
              ref={membershipLevel}
              className="form-select mb-3"
            >
              <option value="35">General Membership — $35.00 USD</option>
              <option value="100">Contributor — $100.00 USD</option>
              <option value="250">Patron — $250.00 USD</option>
              <option value="500">Benefactor — $500.00 USD</option>
              <option value="1000">Altruist — $1,000.00 USD</option>
            </select>
            <PayPalScriptProvider options={initialOptions}>
              <PayPalButtons
                style={{ layout: "vertical" }}
                createOrder={createOrder}
                onApprove={onApprove}
                onError={onError}
              />
            </PayPalScriptProvider>
          </div>
        </div>

        <div className="card" style={{ maxWidth: 520, width: "100%" }}>
          <div className="card-header fsa-card-header">
            <h5
              className="mb-0"
              style={{ color: "white", fontFamily: "inherit" }}
            >
              Join Friends of St. Andrews State Park and receive:
            </h5>
          </div>
          <div className="card-body">
            <ul className="mb-0">
              <li>12 park entries for vehicles with up to eight occupants.</li>
              <li>Access to MEMBERS ONLY events.</li>
              <li>
                Invites to monthly Citizen Science Presentations in the park.
              </li>
              <li>Notice of Special Park Events sponsored by Friends.</li>
              <li>
                Every membership dollar STAYS in the Park to benefit the
                Park&apos;s mission.
              </li>
            </ul>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
